import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { CloseIcon } from '../Icons';
import { IconButton } from '../IconButton';

function DialogHeader({ onClose, title = '', iconComponent = null }) {
	const { t } = useTranslation();

	return (
		<Box
			sx={{
				display: 'flex',
				justifyContent: 'space-between',
				alignItems: 'center',
				borderBottom: '1px solid',
				borderColor: 'divider',
				px: '16px',
				py: '4px',
				minHeight: '48px',
				gap: '12px'
			}}
		>
			<Box
				sx={{
					display: 'flex',
					gap: '6px',
					alignItems: 'center',
					width: '100%'
				}}
			>
				{iconComponent}

				{title && (
					<Typography
						variant="body1"
						fontWeight={500}
						color="text.primary"
					>
						{title}
					</Typography>
				)}
			</Box>

			{onClose && (
				<IconButton
					aria-label={t('common.close')}
					onClick={onClose}
					size="small"
					sx={{
						color: 'text.primary',
						zIndex: 1
					}}
				>
					<CloseIcon />
				</IconButton>
			)}
		</Box>
	);
}

export default DialogHeader;
